// Shared by the React routes and build-time SEO/social metadata.
import services from './data/services.json';
export const SERVICES = services;
export const SERVICES_BY_SLUG = Object.fromEntries(SERVICES.map(service => [service.slug, service]));
